import { type IBaseResponse } from 'platform-core'

import { VERSION } from './constants'
import { submitRequest } from './submit-request'

export default (e: Error): void => {
  const payload = {
    stack: e.stack,
    name: e.name,
    message: e.message != null && e.message !== '' ? e.message : 'An unexpected error occurred.',
    source: 'public-ui',
    metadata: {
      originalUrl: window.location.pathname,
      // When we build the UI, we bake an env var into it
      // If this var isn't present, it's most likely a dev build
      version: process.env.REACT_APP_BUILD_VERSION ?? `ui_${VERSION}_dev`
    }
  }

  // eslint-disable-next-line no-console
  console.error(e)

  submitRequest<IBaseResponse>('post', 'v1/error/ingest', payload)
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error(err)
    })
}
